<template>
  <div
    :class="{ 'mobile-responsive': isMobile }"
    :style="{ 'margin-bottom': displayNewDashboard ? '0px' : '30px' }"
  >
    <the-header :logo="logoImgUrl" :logout="logout" :user-info="user.profile" />
    <transition name="slide">
      <div v-if="isNavOpened">
        <the-sidebar
          ref="sidebar"
          :menu-item-id="this.menuItemId"
          :user-site-map.sync="userMenu"
        />
      </div>
    </transition>
    <main
      class="page-content mt-6"
      :class="{ 'mobile-responsive': isMobile }"
      :style="displayNewDashboard ? { 'background-color': '#F1F6F4' } : {}"
    >
      <router-view />
      <the-help v-if="showHelp" :draggable="true" :items="helpItems" />
      <the-chat-bot
        v-if="showBot"
        :profile="profile"
        :show-prop-chat="showChat"
        @hideChat="hideChat"
      />
    </main>
    <window-resize />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import TheHeader from './TheHeader';
import TheSidebar from './TheSideBar';
import { name as userModuleName } from '@/store/modules/user';
import { name as appModuleName } from '@/store/modules/app';
import { name as studentModuleName } from '@/store/modules/student';
import WindowResize from './WindowResize.vue';
import { getByParameterName } from '@/services/common/sysparameter.api';

import logoUrl from '@/assets/img/logo.svg';
import logoTrainingUrl from '@/assets/img/logo-training.svg';
import TheHelp from 'custom-floating-action-button';
import TheChatBot from '@/components/TheChatBot';

const TICKETS_ROUTE_NAME = 'CaseListMain';

export default {
  name: 'MainLayout',
  components: {
    TheHeader,
    TheSidebar,
    WindowResize,
    TheHelp,
    TheChatBot,
  },
  data() {
    return {
      rightLayoutKey: 0,
      windowWidth: 0,
      helpItems: [],
      botActive: false,
      showChat: false,
      displayNewDasboardParameterValue: false,
    };
  },
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
      isNavOpened: 'getIsNavOpen',
    }),
    ...mapGetters(studentModuleName, {
      isSearchOpened: 'getSearchOpened',
    }),
    ...mapState(userModuleName, ['userMenu', 'menuItemId', 'user']),
    ...mapGetters('$_user', ['fullProfile', 'companies']),
    logoImgUrl() {
      if (this.isTrainingEnv()) return logoTrainingUrl;
      return logoUrl;
    },
    showHelp() {
      return this.helpItems.length > 0;
    },
    showBot() {
      return (
        this.botActive &&
        this.profile &&
        this.userHasPermissions('rp.chatbot.btn')
      );
    },
    profile() {
      return {
        userId: this.userProfile.sub,
        firstname: this.userProfile.firstname,
      };
    },
    displayNewDashboard() {
      return this.$route.path == '/' && this.displayNewDasboardParameterValue;
    },
  },
  async mounted() {
    window.location.hash = '';

    const { data } = await getByParameterName('DisplayNewDashboardRemPro');
    this.displayNewDasboardParameterValue =
      data.value?.toLowerCase() == 'true' ?? false;
    this.getBotParameter();
  },
  methods: {
    ...mapActions(userModuleName, ['logout']),
    setPushElements(key, values) {
      if (values != null) {
        this.setPopElements(key, values);

        for (const el of values) {
          this.catalog[key].push(el);
        }
      }
    },
    setPopElements(key, values) {
      for (const el of values) {
        this.catalog[key].pop(el);
      }
    },
    refreshLayoutHandler() {
      this.rightLayoutKey += 1;
    },
    async getBotParameter() {
      const { data } = await getByParameterName('ActivateRPBot');

      if (data && data.value) {
        this.botActive = data.value;

        if (this.showBot) {
          this.helpItems.push(
            {
              label: 'Mesa de Apoyo',
              icon: 'fal fa-user-headset',
              styles: {
                background: '#2DB782',
                color: '#fff',
              },
              action: this.goToTickets,
            },
            {
              label: 'Asistente Virtual',
              icon: 'fal fa-comment',
              styles: {
                background: '#fff',
                color: '#2DB782',
              },
              action: this.showBotChat,
            }
          );
        }
      }
    },
    showBotChat() {
      this.showChat = true;
    },
    hideChat() {
      this.showChat = false;
    },
    goToTickets() {
      this.$router.push({ name: TICKETS_ROUTE_NAME });
    },
  },
};
</script>

<style scope>
#main {
  margin-bottom: 30px;
}

.page-content {
  margin-left: 118px;
  padding: 30px;
}

.blured-body {
  left: 119px;
  top: 100px;
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 11;
}

.blured-body {
  backdrop-filter: blur(8px);
}
</style>
